var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "d-md-flex h-md-100 align-items-center" }, [
      _vm._m(0),
      _c("div", { staticClass: "col-md-5 p-0 bg-white h-md-100 loginarea" }, [
        _c(
          "div",
          { staticClass: "d-md-flex col-12 align-top" },
          [
            _c("img", {
              staticStyle: { "padding-top": "10px" },
              attrs: {
                src: require("@/resources/img/ktb-logo.png"),
                width: "152",
                height: "56"
              }
            }),
            _c("img", {
              attrs: {
                src: require("@/resources/img/h_elg.jpg"),
                width: "284",
                height: "58"
              }
            }),
            _c("router-link", { attrs: { to: "Login" } }, [
              _c("img", {
                attrs: {
                  src: require("@/resources/img/login.jpg"),
                  width: "59",
                  height: "58"
                }
              })
            ])
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass:
              "align-items-center h-md-100 p-5 justify-content-center"
          },
          [
            _c("form", { staticClass: "rounded p-5" }, [
              _c("div", { staticClass: "form-group material-form" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.username,
                      expression: "username"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    required: "",
                    type: "text",
                    placeholder: "Username"
                  },
                  domProps: { value: _vm.username },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.username = $event.target.value
                      },
                      function($event) {
                        _vm.username = $event.target.value.toUpperCase()
                      }
                    ],
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.login()
                    }
                  }
                }),
                _c("span", { staticClass: "highlight" }),
                _c("span", { staticClass: "bar" }),
                _c(
                  "label",
                  { staticClass: "have-text", attrs: { for: "usernameLogin" } },
                  [_vm._v("ชื่อรหัสผู้ใช้")]
                )
              ]),
              _c("div", { staticClass: "form-group material-form" }, [
                _c(
                  "label",
                  { staticClass: "have-text", attrs: { for: "passwordLogin" } },
                  [_vm._v("รหัสผ่าน")]
                ),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.password,
                      expression: "password"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    required: "",
                    type: "password",
                    placeholder: "Password",
                    autocomplete: "off"
                  },
                  domProps: { value: _vm.password },
                  on: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.login()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.password = $event.target.value
                    }
                  }
                }),
                _c("span", { staticClass: "highlight" }),
                _c("span", { staticClass: "bar" })
              ]),
              _c("div", { staticClass: "form-group material-form" }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        _vm.toggle = !_vm.toggle
                      }
                    }
                  },
                  [_vm._v("2FA")]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.toggle,
                        expression: "!toggle"
                      }
                    ]
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.fa2,
                          expression: "fa2"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { required: "", type: "fa2", placeholder: "2FA" },
                      domProps: { value: _vm.fa2 },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.fa2 = $event.target.value
                        }
                      }
                    }),
                    _c("span", { staticClass: "highlight" }),
                    _c("span", { staticClass: "bar" })
                  ]
                )
              ]),
              _c(
                "button",
                {
                  staticClass: "btn btn-info btn-round btn-block shadow-sm",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.login()
                    }
                  }
                },
                [_vm._v("\n            เข้าสู่ระบบ\n          ")]
              )
            ])
          ]
        )
      ])
    ]),
    _vm._m(1)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-md-7 p-0 bg-indigo h-md-100 logoarea" },
      [
        _c(
          "div",
          {
            staticClass:
              "text-white d-md-flex align-items-center h-100 p-5 text-center justify-content-center"
          },
          [_c("div", { staticClass: "pt-5 pb-5" })]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("footer", { staticClass: "ft-content space-up" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-6 text-left" }, [
            _c("i", { staticClass: "feather-icon icon-phone" }),
            _c("span", [_vm._v("02-111-1111, 02-111-9999 KTB Call Center")])
          ]),
          _c("div", { staticClass: "col-6 text-right" }, [
            _c("span", { staticClass: "text-red" }, [
              _vm._v(
                "การทำรายการหลังเวลา 15.00 น.\n            ถือว่าเป็นการทำรายการของวันทำการถัดไป"
              )
            ]),
            _c("br"),
            _c("i", { staticClass: "fa fa-copyright" }),
            _c("span", [_vm._v("สงวนสิทธิ์ พ.ศ. 2562 บมจ. ธนาคารกรุงไทย")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }